
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class PassengerAvatar extends Vue {
  @Prop({ required: true }) passenger!: IPassenger;

}

